import { CForm } from '@coreui/react'
import React, { createRef, useState } from 'react'
import { topImage } from '../../../../../components/imageLoader'
import { changeLanguage, checkForNumericFaString, toEnglishNumber } from '../../../../../components/helper'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import { FooterIonSVG, UserLogin } from '../../../../../components/IconSvg'
import * as Yup from 'yup';
import { toast } from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom'
const numerOfInputs = 6;

const VCodeLogin = () => {
    const [widthScreen, setWidthScreen] = useState(window.innerWidth)
    const [inputRefsArray] = useState(() => Array.from({ length: numerOfInputs }, () => createRef()));
    const [letters, setLetters] = useState(() => Array.from({ length: numerOfInputs }, () => ""));
    const navigate = useNavigate();

    const { t, i18n } = useTranslation()
    let direction = i18n.dir()

    const validation = Yup.object({
        email: Yup.string().email(t("ERRORS.EMILE_INVALID") || "").required(t("ERRORS.EMILE_REQ") || ""),

    })


    const handleSubmit = (value: { email: string }) => {
        navigate("/loginInstances", { state: { email: value.email } })
    }
    const formik = useFormik({
        validationSchema: validation,
        initialValues: { email: '' },
        onSubmit: handleSubmit,
    })
    const getFromClipboard = (e: any) => {
        e.preventDefault();
        if (e.clipboardData.getData('text')) {
            const temp = e.clipboardData.getData('text').toString()
            setLetters([...temp.split('')])
            handleVerificationCode(undefined, temp)
        }
    }
    const handleVerificationCode = (e: any, _letters: any[] = []) => {
        if (e !== undefined) {
            e.preventDefault()
        }

        let verificationCodeTotal = _letters ? _letters : ''

        if (verificationCodeTotal === '') {
            letters.forEach((item, index: number) => {
                let newItem = checkForNumericFaString(item) ? toEnglishNumber(item) : item
                verificationCodeTotal = verificationCodeTotal + newItem
            })

        }


        if (verificationCodeTotal !== '') {

        }
        else {
            toast.error(t("ERROR_VERIFICATION_CODE"))
        }

    }

    return (
        <div className={`d-flex flex-row justify-content-between auth-form `}>
            <div className='section-right' >
                <div className='d-flex flex-row justify-content-between head-tools-context' >
                    <a href='https://dartamas.com/' className='text-decoration-none'>
                        <button className='btn btn-default main-page-btn' type="button"
                        // onClick={(e) => { navigate("/") }}
                        >{t('MAIN.PAGE_SITE')}</button>

                    </a>
                    <div className='d-flex flex-column justify-content-start' >
                        <div className='d-flex flex-row justify-content-end'>
                            <button className='btn btn-default main-page-btn' style={{ width: '40px' }} onClick={() => changeLanguage(i18n, direction)} >{direction === 'ltr' ? 'فا' : 'En'}</button>
                        </div>
                        <img className="top-image" src={topImage} alt="" />
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-center' >
                    <div className='login-section '>
                        <div className='icon-login d-flex flex-row justify-content-center'><UserLogin styles={undefined} /></div>
                        <h4 className='icon-title d-flex flex-row justify-content-center'><b>{t('ENTER')}</b></h4>
                        {/* <p className='login-email-enter d-flex flex-row justify-content-center'>{t('ENTER_LOGIN_EMAIL')}</p> */}
                        <div className='login-type-btn-container' >
                            <Link to="/login">ورود با کلمه عبور</Link>
                            <Link to="/vcodeLogin" className='active'>ورود با رمز یکبار مصرف</Link>

                        </div>
                        <CForm onSubmit={formik.handleSubmit} >
                            {/* <label >{t('EMAIL')}:</label> */}

                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className='d-flex flex-row justify-content-start lbl-frm' >{t('COLUMNS.EMAIL')}</label>

                                <input type='email' name="email" id="exampleInputEmail1"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className='form-control' placeholder={t('COLUMNS.EMAIL') || ""} />
                                {formik.errors.email && formik.touched.email && <label className='label-danger '>{formik.errors.email}</label>}
                            </div>

                            <div className="form-group">
                                <div className='d-flex flex-row justify-content-between  btn-verify-holder' style={{ direction: 'ltr' }}>

                                    {inputRefsArray.map((ref, index) => {
                                        return (
                                            <input
                                                onPaste={(e) => getFromClipboard(e)}
                                                key={index}
                                                // ref={ref}
                                                type={widthScreen > 900 ? "text" : "number"}
                                                id={`box${index}-1`}
                                                // onChange={(e) => { onChange(e, index) }}
                                                // onClick={(e) => { onClick(e, index) }}
                                                value={letters[index]}
                                                max={"1"}
                                                maxLength={1}
                                                autoComplete="xyz123"
                                                name='new-code'
                                            />

                                        );
                                    })
                                    }
                                </div>
                                <div className='d-flex justify-content-end code-time-container' >
                                    <label>00:00</label> <span>دریافت رمز</span>
                                </div>
                            </div>








                            <div className='d-flex flex-row justify-content-between'>
                                <button className="btn btn-primary auth-form-btn w-100"
                                    disabled={false}
                                    type="submit" >  {(false) ?
                                        <div className="spinner-border" role="status" aria-hidden="true"></div> : t('LOGIN')}</button>
                                {/* <button className="btn btn-default auth-form-btn"
                                onClick={(e) => { linkBtn(e) }} >{type === 'register' ? t('LOGIN') : t('REGISTER')}</button> */}
                            </div>
                            <div className='login-footer d-flex flex-row justify-content-start'>
                                <span className='icon-login-footer d-flex flex-column justify-content-center'><FooterIonSVG styles={undefined} /></span>
                                <div className=' text-login-footer'>
                                    <span>
                                        {t('FOOTER_LOGIN_TEXT-SECTION_ONE')}
                                    </span>
                                    <a target='_blank' className='link-style' href='https://dartamas.com/privacy-policy/'>{t('LINK_FOOTER')}</a>
                                    <span >‌{t('FOOTER_LOGIN_TEXT-TWO')}</span>
                                </div>
                            </div>

                        </CForm>
                        <div className='Copywriter d-flex flex-row justify-content-center' style={{ direction: 'ltr' }}>
                            <p>{t('COPY_WRITE')}</p>
                        </div>
                    </div>
                </div>
                {/* <div className='d-flex flex-column justify-content-start' >
                <div className='d-flex flex-row justify-content-end'>
                    <button className='btn btn-default main-page-btn' style={{ width: '40px' }} onClick={changeLanguege} >{direction === 'ltr' ? 'فا' : 'En'}</button>
                </div>
                <img className="top-image" src={topImage} alt="" />
            </div> */}

            </div>
            {widthScreen > 1024 ? <div
                className={`image-container`}>
                <div className={`${i18n.language === 'fa' ? 'fa' : 'en'}`}></div>
                {/* <img className='section-left-img' style={i18n.language === 'fa' ? { left: '25px' } : { right: '25px' }} src={i18n.language === 'fa' ? loginRight : loginLeft} alt="" /> */}
            </div> : ''}

        </div>
    )
}

export default VCodeLogin